// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetThemeDarkResponse

export type WidgetThemeDarkApiResponse = {
	primary: string;
	background: string;
	inversedHeaderTextColor: boolean;
	pageBackgroundColor: string | null;
};

export type WidgetThemeDark = {
	primary: string;
	background: string;
	inversedHeaderTextColor: boolean;
	pageBackgroundColor: string | null;
};

export function hydrateWidgetThemeDark(data: WidgetThemeDarkApiResponse): WidgetThemeDark {
	return { ...data };
}